const iceBoxProcess = () => import('Views/iceBoxProcess/iceBox-process');
const iceBoxProcessTime = () => import('Views/iceBoxProcess/iceBox-process-time');

export default[
  { path: '/iceBox-process', component: iceBoxProcess },
  { path: '/iceBox-process-time', component: iceBoxProcessTime },
];



// WEBPACK FOOTER //
// ./src/router/iceBoxProcess.js